import { render } from "./BookTypeForm.vue?vue&type=template&id=74d42d5f"
import script from "./BookTypeForm.vue?vue&type=script&lang=js"
export * from "./BookTypeForm.vue?vue&type=script&lang=js"

import "./BookTypeForm.vue?vue&type=style&index=0&id=74d42d5f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__